module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-02.d929cd82.jpg";